/* Product */
import '../partials/product/product-slider/product-slider';
// import '../partials/product/product-slider/zoomsl';
import '../partials/product/product-info/product-info';
import '../partials/product/product-description/product-description';
import '../partials/product/wish-list/wish-list-add/wish-list-add';
import '../partials/product/relative-product-slider/relative-product-slider';

/* Review */
import '../partials/content/review/review-add/review-add';
import '../partials/content/review/review-list/review-list';

/* size */
import '../partials/content/size/size';


//image zoom
import './../libs/jquery.zoom.min.js';
$(document).ready(function(){
    $('.product-slider__slide.swiper-slide').each(function( index ) {
       var src = $(this).find('img').attr('data-src');
       $(this).zoom({url: src});
    });
});
  
